const getListFromFlow = (flow, listType) => {
  return flow.associatedLists.find(list => list.listTypes.includes(listType));
};
const getListsFromFlow = (flow, listType) => {
  return flow.associatedLists.filter(list => list.listTypes.includes(listType));
};
const getEventFiltersFromFlow = (flow, ...filterTypes) => {
  return flow.flowEventFilters.filter(filter => filterTypes.includes(filter.flowEventFilterType));
};
export const getEnrollmentEventFilters = flow => {
  return getEventFiltersFromFlow(flow, 'FIRST_TIME_ENROLLMENT', 'ANY_ENROLLMENT');
};
export const getReEnrollmentEventFilters = flow => {
  return getEventFiltersFromFlow(flow, 'ANY_ENROLLMENT');
};
export const getFlowEventFilterByFilterId = (flow, {
  filterId,
  filterVersion
}) => {
  return flow.flowEventFilters.find(filter => filter.eventFilterId.id === filterId && filter.eventFilterId.version === filterVersion);
};
export const getHybridEnrollmentList = flow => {
  return getListFromFlow(flow, 'ENROLLMENT_LIST');
};
export const getRefinementList = flow => {
  return getListFromFlow(flow, 'REFINE_BY_LIST');
};
export const getPersistedReenrollmentLists = flow => {
  return getListsFromFlow(flow, 'PERSISTED_RE_ENROLLMENT_LIST');
};
export const getClassicEnrollmentTriggers = flow => {
  return flow.classicEnrollmentSettings && flow.classicEnrollmentSettings.enrollmentFilters;
};
const getHybridReEnrollmentList = flow => {
  return getListFromFlow(flow, 'RE_ENROLLMENT_LIST');
};
const LIST_EVENT_TRIGGER_TYPES = ['ADDED_TO_LIST_TRIGGER', 'REMOVED_FROM_LIST_TRIGGER'];
const expandListBasedEventTriggerTypes = list => {
  return list.listTypes.filter(listType => LIST_EVENT_TRIGGER_TYPES.includes(listType)).map(listType => Object.assign({}, list, {
    listTypes: [listType]
  }));
};

// Grabs the list triggers of type ADDED_TO_LIST and REMOVED_FROM_LIST and maps them to individual new lists for the FE to digest
export const getListEventTriggers = flow => {
  return flow.associatedLists.map(expandListBasedEventTriggerTypes).flat();
};
export const getContactGoalList = flow => {
  return getListFromFlow(flow, 'CLASSIC_GOAL_LIST');
};
export const getSuppressionLists = flow => {
  return getListsFromFlow(flow, 'SUPPRESSION_LIST');
};
export const getFlowHasEnrollmentCriteria = flow => {
  const hasILSEnrollmentList = !!getHybridEnrollmentList(flow);
  const clsEnrollmentFilters = getClassicEnrollmentTriggers(flow);
  const hasCLSEnrollmentCriteria = !!clsEnrollmentFilters && clsEnrollmentFilters.length > 0;
  const hasEventTriggersEnrollmentFilters = getEnrollmentEventFilters(flow).length > 0;
  const hasListEventTriggers = getListEventTriggers(flow).length > 0;
  return hasCLSEnrollmentCriteria || hasILSEnrollmentList || hasEventTriggersEnrollmentFilters || hasListEventTriggers;
};
export const getHasCLSReenrollment = flow => {
  return Boolean(flow.classicEnrollmentSettings && flow.classicEnrollmentSettings.reEnrollmentTriggerSets && flow.classicEnrollmentSettings.reEnrollmentTriggerSets.length > 0);
};
export const getFlowHasReenrollmentCriteria = flow => {
  const hasILSReenrollmentList = !!getHybridReEnrollmentList(flow);
  const hasCLSReenrollmentList = getHasCLSReenrollment(flow);
  const hasEventTriggersReEnrollmentFilters = getReEnrollmentEventFilters(flow).length > 0;
  const hasListEventReenrollmentTriggers = flow.shouldReenroll && getListEventTriggers(flow).length > 0;
  const hasPersistedReenrollmentLists = getPersistedReenrollmentLists(flow).length > 0;
  return hasILSReenrollmentList || hasCLSReenrollmentList || hasEventTriggersReEnrollmentFilters || hasListEventReenrollmentTriggers || hasPersistedReenrollmentLists;
};